<template>
  <div
    :class="$style['main-game']"
    @click="userStore.toGame('/games/contracts')"
    @mouseleave="overHover"
    @mouseover="onHover"
  >
    <div :class="$style['lottie-contracts']">
      <client-only>
        <Vue3Lottie
          ref="lottieAnimation"
          :animation-data="contracts"
          :loop="false"
          :autoplay="false"
        />
      </client-only>
    </div>
    <GameInfo
      :game-name="t('mini_games.contracts')"
      :game-icon="'ContractsIcon'"
      :game-class="'main'"
    />
  </div>
</template>

<script setup lang="ts">
import GameInfo from "./GameInfo.vue";
import contracts from "~/public/mini_games/contracts.json";
const userStore = useUserStore();
const { t } = useI18n();

const lottieAnimation = ref(null);

onMounted(() => {
  setTimeout(() => {
    // @ts-ignore
    if (lottieAnimation.value) lottieAnimation.value.stop();
  }, 100);
});

const onHover = () => {
  // @ts-ignore
  lottieAnimation.value.setDirection("forward");
  // @ts-ignore
  if (lottieAnimation.value) lottieAnimation.value.play();
};

const overHover = () => {
  if (lottieAnimation.value) {
    // @ts-ignore
    lottieAnimation.value.setDirection("reverse");
    // @ts-ignore
    if (lottieAnimation.value) lottieAnimation.value.play();
  }
};
</script>

<style lang="scss" module>
.main-game {
  position: relative;
  display: flex;
  width: 50%;
  border-radius: 32px;
  padding: 32px;
  cursor: pointer;
  background-color: var(--general-underlay-3-lvl);
  background-image: radial-gradient(
    102.83% 95.54% at 94.85% 109.82%,
    rgba(69, 149, 255, 0.75) 0%,
    rgba(255, 36, 175, 0) 100%
  );
  overflow: hidden;

  .lottie-contracts {
    position: absolute;
    right: 0;
    height: 100%;

    @media screen and (max-width: 900px) {
      bottom: -15%;
    }
    @media screen and (max-width: 750px) {
      bottom: -20%;
    }
    @media screen and (max-width: 650px) {
      width: 100%;
      bottom: -10%;
    }
    @media screen and (max-width: 375px) {
      bottom: -17%;
    }
  }

  @media screen and (max-width: 650px) {
    width: 350px;
    height: 361px;
  }
  @media screen and (max-width: 380px) {
    width: 100%;
  }
}
</style>
